import { pick } from 'lodash';
import { ProvisioningStatusFilter } from '@/activityLog/bulkProvisioning/constants/provisioningStatus.ts';
import { cleanDefaultValuesURLSearchParams } from 'common/utils/urlSearchParamsUtils.ts';
import {
  PRODUCTS_MANAGEMENT_INITIAL_VALUES,
  ProductsManagementFilters,
} from 'atoms/filters/products-management-filters.ts';

export const mapProductManagementFiltersToURLSearchParams = (
  filters: ProductsManagementFilters,
) => {
  const filtersAsStrings = {
    ...filters,
    uploadDateFrom: filters.uploadDateFrom ? filters.uploadDateFrom.toISOString() : null,
    uploadDateTo: filters.uploadDateTo ? filters.uploadDateTo.toISOString() : null,
  };

  const cleanedFiltersValues = cleanDefaultValuesURLSearchParams(
    {
      ...filtersAsStrings,
    },
    {
      ...PRODUCTS_MANAGEMENT_INITIAL_VALUES,
      uploadDateFrom: null,
      uploadDateTo: null,
    },
  );

  return new URLSearchParams({
    ...cleanedFiltersValues,
  });
};

export const mapURLSearchParamsToProductManagementFilters = (
  urlSearchParams: URLSearchParams,
): ProductsManagementFilters => {
  const filters = Object.fromEntries(urlSearchParams);

  const { status, uploadDateFrom, uploadDateTo } = pick(
    filters,
    Object.keys(PRODUCTS_MANAGEMENT_INITIAL_VALUES),
  );

  return {
    ...PRODUCTS_MANAGEMENT_INITIAL_VALUES,
    status: status
      ? (status as ProvisioningStatusFilter)
      : PRODUCTS_MANAGEMENT_INITIAL_VALUES.status,
    uploadDateFrom: uploadDateFrom
      ? new Date(uploadDateFrom)
      : PRODUCTS_MANAGEMENT_INITIAL_VALUES.uploadDateFrom,
    uploadDateTo: uploadDateTo
      ? new Date(uploadDateTo)
      : PRODUCTS_MANAGEMENT_INITIAL_VALUES.uploadDateTo,
  };
};
